import { openBlock as t, createElementBlock as a, createStaticVNode as e } from "vue";
const l = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 40 40"
}, o = /* @__PURE__ */ e('<path fill="#FFDA44" d="M20 40c11.046 0 20-8.954 20-20S31.046 0 20 0 0 8.954 0 20s8.954 20 20 20Z"></path><path fill="#D80027" d="M23.042 39.77a19.893 19.893 0 0 0 8.785-3.642L20 20l3.042 19.77ZM16.959.23a19.895 19.895 0 0 0-8.786 3.642L20 20 16.96.23ZM8.173 36.128a19.896 19.896 0 0 0 8.785 3.642L20 20 8.173 36.128ZM3.872 8.173A19.895 19.895 0 0 0 .23 16.958L20 20 3.872 8.173ZM.23 23.041a19.893 19.893 0 0 0 3.642 8.786L20 20 .23 23.04Zm39.54-6.083a19.895 19.895 0 0 0-3.642-8.785L20 20l19.77-3.042ZM31.827 3.872A19.894 19.894 0 0 0 23.042.23L20 20 31.827 3.872Zm4.301 27.955a19.896 19.896 0 0 0 3.642-8.785L20 20l16.128 11.827Z"></path><path fill="#D80027" d="M20 26.956a6.956 6.956 0 1 0 0-13.913 6.956 6.956 0 0 0 0 13.913Z"></path><path fill="#FFDA44" d="M20 25.217a5.217 5.217 0 1 0 0-10.434 5.217 5.217 0 0 0 0 10.434Z"></path><path fill="#D80027" d="M20 26.956a6.956 6.956 0 1 0 0-13.913 6.956 6.956 0 0 0 0 13.913Z"></path><path fill="#FFDA44" d="M20 25.217a5.217 5.217 0 1 0 0-10.434 5.217 5.217 0 0 0 0 10.434Z"></path>', 6), h = [
  o
];
function p(c, i) {
  return t(), a("svg", l, [...h]);
}
const d = { render: p };
export {
  d as default,
  p as render
};
